<template>
  <!-- Mobile -->
  <v-dialog
    v-if="$vuetify.display.xs"
    v-model="mobileSearchDialog"
    fullscreen
    :scrim="false"
    transition="dialog-bottom-transition"
  >
    <template #activator="{ props }">
      <v-btn :icon="mdiMagnify" v-bind="props">
        <v-icon>search</v-icon>
      </v-btn>
    </template>

    <v-card rounded="0">
      <v-card-title class="py-2">
        <v-toolbar-title>Search for funds or securities</v-toolbar-title>
        <v-spacer />
        <v-btn :icon="mdiClose" class="ma-0" @click="mobileSearchDialog = false"> </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select v-model="filter" item-title="text" :items="filterItems" return-object />
        <v-autocomplete
          ref="autocomplete"
          v-model:search-input="searchInput"
          v-model="selectedResult"
          :items="searchResults"
          :loading="loading"
          :hide-no-data="!searchInput || searchInput.length < 3 || loading"
          no-data-text="No such fund found"
          return-object
          clear-on-select
          no-filter
          item-title="label"
          item-value="id"
          placeholder="Search for funds/stocks"
          :prepend-inner-icon="mdiMagnify"
          append-icon=""
          @update:search="querySearch"
          @keydown.enter="FilerStockSearch(searchInput)"
        >
          <template #item="data">
            <v-list-item :href="genUrl(data.item.raw)">
              <v-list-item-title>
                {{ data.item.raw.labelTop }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.raw.labelBottom }}
              </v-list-item-subtitle>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Tablet & Desktop -->
  <div v-else class="app-toolbar__search-container">
    <div class="app-toolbar__select mr-1">
      <v-select
        v-model="filter"
        :items="filterItems"
        return-object
        theme="dark"
        solo
        item-title="text"
        density="compact"
        text
        hide-details
      />
    </div>
    <div class="app-toolbar__autocomplete">
      <v-autocomplete
        ref="autocomplete"
        v-model:search-input="searchInput"
        v-model="selectedResult"
        no-filter
        :items="searchResults"
        :loading="loading"
        :hide-no-data="!searchInput || searchInput.length < 2 || loading"
        no-data-text="No matching results found"
        return-object
        item-title="label"
        item-value="id"
        placeholder="Search for funds/stocks"
        :prepend-inner-icon="mdiMagnify"
        append-icon=""
        theme="light"
        variant="solo"
        density="compact"
        hide-details
        @update:search="querySearch"
        @keydown.enter="FilerStockSearch(searchInput)"
      >
        <template #item="{ props, item }">
          <v-list-item
            :href="genUrl(item.raw)"
            v-bind="props"
            :link="true"
            :title="item.raw.labelTop"
            :subtitle="item.raw.labelBottom"
            @keydown.enter="navigateTo(genUrl(item.raw))"
          >
          </v-list-item>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
// Modules
import { apiRoot } from '@/store/api'
import { mdiClose, mdiMagnify } from '@mdi/js'

export default {
  data() {
    return {
      mdiMagnify: mdiMagnify,
      mdiClose: mdiClose,
      mobileSearchDialog: false,
      loading: false,
      searchInput: '',
      searchResults: [],
      searchValue: '',
      selectedResult: [],
      filerStockSearchResults: [],
      show_filer_stock_search_results: false,
      filter: { text: 'Active', value: 6 },
      filterItems: [
        { text: 'All', value: 0 },
        { text: '13F Filers Only', value: 1 },
        { text: 'SEC Filer', value: 2 },
        { text: 'Stocks Only', value: 3 },
        { text: 'Mgmt Inv. Cos Only', value: 4 },
        { text: 'ETFs Only', value: 5 },
        { text: 'Active', value: 6 }
      ]
    }
  },

  watch: {
    filter(newFilter) {
      // 1 year from now
      const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))

      this.$cookies.set('search_filter', newFilter.value, { expires: expiryDate })
    }

    /*searchInput (val) {
      val && val.length > 2 && this.querySearch(val)
      this.searchInput = null
    }*/
  },

  created() {
    const cookie = this.$cookies.get('search_filter')

    if (!cookie) {
      // 1 year from now
      const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))

      // If we haven't created a search_filter cookie yet,
      // set filterItems[6] ('Active') as the default filter
      this.$cookies.set('search_filter', this.filterItems[6].value, { expires: expiryDate })
    } else {
      this.filter = this.filterItems[cookie]
    }
  },

  methods: {
    querySearch(val) {
      if (val && val.length > 0) this.searchValue = val
      if (!val || (val && val.trim().length == 0)) return
      // this.setCookie();
      if (val.length > 30) {
        val = val.substring(0, 30)
      }
      const query = `search/filer_stock_autocomplete2?filer_restrictions=${this.filter.value}&term=${encodeURIComponent(val)}`
      if (this.loading) return
      this.loading = true
      /* let data = (await this.$axios.get(query)).data;
      this.searchResults = data.map((obj) => {
        obj.labelTop = obj.label.split("<br/>")[0];
        obj.labelBottom = obj.label.split("<br/>")[1];
        this.loading = false;
        return obj;
      });*/
      this.loading = false
      apiRoot
        .get(query)
        .then(res => {
          this.searchResults = res.data.map(obj => {
            obj.labelTop = obj.label.split('<br/>')[0]
            obj.labelBottom = obj.label.split('<br/>')[1]
            return obj
          })
        })
        .then(() => (this.loading = false))
    },
    FilerStockSearch() {
      if (this.selectedResult.length > 0) return
      // this.$cookies.set('search_filter', this.filter.value, { expires: expiryDate })``
      // this.setCookie();
      const query = `search/filer_stock_search2?filer_restrictions=${this.filter.value}&search_phrase=${this.searchValue}`
      if (this.loading) return
      this.loading = true
      apiRoot
        .get(query)
        .then(data => {
          this.filerStockSearchResults = data.data
          this.show_filer_stock_search_results = true
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => (this.loading = false))

      /* apiRoot.get(query)
        .then(res => {
          this.searchResults = res.data.map(obj => {
            obj.labelTop = obj.label.split('<br/>')[0]
            obj.labelBottom = obj.label.split('<br/>')[1]
            return obj
          })
        })
        .then(() => (this.loading = false))*/
    },

    genUrl(item) {
      const rectype = item.rectype === 'filer' ? 'filer' : 'stock'

      return `/${rectype}/${item.permalink}`
    },
    navigateTo(url) {
      window.location.href = url
    }
    /*querySearch (val) {
      const query = `search/filer_stock_autocomplete2?filer_restrictions=${this.filter.value}&term=${encodeURIComponent(val)}`

      this.loading = true

      apiRoot.get(query)
        .then(res => {
          this.searchResults = res.data.map(obj => {
            obj.labelTop = obj.label.split('<br/>')[0]
            obj.labelBottom = obj.label.split('<br/>')[1]
            return obj
          })
        })
        .then(() => (this.loading = false))
    },

    genUrl (item) {
      const rectype = item.rectype === 'filer' ? 'filer' : 'stock'

      return `/${rectype}/${item.permalink}`
    }*/
  }
}
</script>

<style lang="scss">
#app-toolbar {
  .app-toolbar__search-container {
    display: flex;

    .app-toolbar__select {
      width: 150px;
    }
    .app-toolbar__autocomplete {
      width: 300px;
    }
  }
}
</style>
